import React, {Component} from 'react'
import {Modal, Button, Table, Switch} from 'antd'
import { DeleteOutlined, QuestionCircleFilled, SwapOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'

const {confirm} = Modal
let downloadId = null
let currentPageNumber = 1

@inject('reportManagementStore')
@observer
class SearchDataModal extends Component {
  formRef = React.createRef()
  state = {
    page: 1, // 当前页
    size: 10, // 每页显示条数
    total: null, // 总条数
    tableData: [],
    tableLoading: false,
    generateButtonLoading: false,
    timer: null,
  }

  handleOk = () => {
    const {handleCancel, reportManagementStore, reportId} = this.props

    this.formRef.current.validateFields().then(fieldsValue => {
      reportManagementStore.saveReport({...fieldsValue, id: reportId}).then(res => {
        if (res.code === 0) {
          handleCancel('searchModalVisible')
        }
      })
    })
  }

  handleSearch = (pageNumber, pageSize) => {
    this.setState({tableLoading: true})
    const {reportManagementStore, reportId} = this.props
    const {page, size} = this.state

    let params = {
      pageNo: pageNumber ? pageNumber : page,
      pageSize: pageSize ? pageSize : size,
      reportId: reportId
    }
    reportManagementStore.getReportSearchData(params).then(res => {
      if (res?.code === 0) {

        this.setState({
          tableData: res.data?.records,
          page: pageNumber ? pageNumber : page, // 当前页
          size: pageSize ? pageSize : size, // 每页显示条数
          total: res.data?.total // 总条数
        })
        currentPageNumber = pageNumber
      }
      this.setState({tableLoading: false})
    }).catch(() => {
      this.setState({tableLoading: false})
    })
  }

  generateReport = () => {
    this.setState({generateButtonLoading: true})
    const {reportManagementStore, generateParams} = this.props

    reportManagementStore.generateReport(generateParams).then(res => {
      if (res.code === 0) {
        this.handleSearch(1, 10)
        downloadId = Number(res.data)
      }
      this.setState({generateButtonLoading: false})
    }).catch(() => {
      this.setState({generateButtonLoading: false})
    })
  }

  handleDownload = filePath => {
    window.open(filePath, '_self')
  }

  handleDelete = id => {
    const {t, reportManagementStore} = this.props
    let _this = this

    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        reportManagementStore.deleteReportSearchData(id).then(() => {
          _this.handleSearch()
        })
      },
      onCancel() {
        console.log('Cancel')
      },
    })
  }

  handleUse = (id, checked) =>  {
    const {t, reportManagementStore, handleUseSearch} = this.props
    let _this = this

    confirm({
      title: t(`general.defaultUse`),
      icon: <QuestionCircleFilled />,
      content: t(`general.defultUse`),
      okText: t(`general.ok`),
      cancelText: t(`general.cancel`),
      onOk() {

        reportManagementStore.updateUseReportSearchData(id).then(() => {
          _this.handleSearch()
          // handleUseSearch('searchModalVisible')
        })
      },
      onCancel() {
        console.log('Cancel')
      },
    })
  }

  handleTemporaryUse = searchData => {
    const { reportManagementStore, handleUseSearch } = this.props
   let jsonArray = JSON.parse(searchData)
    const updatedReportPageCondition = reportManagementStore.reportPageCondition.map(condition => {
      const match = jsonArray.find(item => item.name === condition.name);
      
      if (match) {
        return {
          ...condition,
          value: match.value
        };
      }else{
        return {
          ...condition,
          value: null
        };
      }
      return condition;
    });

    reportManagementStore.setReportPageCondition(updatedReportPageCondition).then(() => {
      handleUseSearch('searchModalVisible')
    })
  }
  

  closeModal = () => {
    const {handleCancel} = this.props

    handleCancel('searchModalVisible')
  }

  componentDidMount() {
        this.handleSearch(currentPageNumber, 10)
  }



  render() {
    const {t, modalVisible, handleCancel, reportName} = this.props
    const {page, size, total, tableData, tableLoading} = this.state
    const pagination = getPaginationConfig(page, size, total, this.handleSearch)
    const columns = tableData.length > 0 ? JSON.parse(tableData.reduce((max, current) => {
      const maxLength = JSON.parse(max.searchData).length;
      const currentLength = JSON.parse(current.searchData).length;
      return currentLength > maxLength ? current : max;
    }).searchData) : [];
    
        // // 解析每个对象的 searchData 作为 dataSource
        // const dataSource = tableData.map((item) => {
        //     const parsedData = JSON.parse(item.searchData);
        //     const dataObject = {};
        //     parsedData.forEach((field) => {
        //       let value = field.value;
        //       if (typeof value === 'string' && value.trim().startsWith('[') && value.trim().endsWith(']')) {
        //         try {
        //           value = JSON.parse(value);
        //           if (Array.isArray(value)) {
        //             value = value.join(', ');
        //           }
        //         } catch (e) {
        //           console.error('Failed to parse field.value as JSON:', e);
        //           value = value || '';
        //         }
        //       } else if (Array.isArray(value)) {
        //         value = value.join(', ');
        //       }
        //       dataObject[field.name] = value || '';
        //     });
        //     return {
        //       ...dataObject,
        //       id: item.id, // 使用 createTime 作为唯一标识符
        //       status: item.status, // 使用实际的 status 值
        //       createTime: item.createTime,
        //       isUse: item.isUse,
        //     };
        //   });


          const additionalColumns = [
            {
              title: t(`reportManagement.title`),
              dataIndex: 'title',
              key: 'title',
              ellipsis: true,
            },
            
            {
              title: t(`reportManagement.createTime`),
              dataIndex: 'createTime',
              key: 'createTime',
              ellipsis: true,
              render: (text) => {
                const date = new Date(text);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
          
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
              },
            },
            {
              title: t(`reportManagement.isUse`),
              dataIndex: 'isUse',
              key: 'isUse',
              ellipsis: true,
              render: (text, record) => {
                return (
                  <Switch
                    checked={text}
                    onChange={(checked) => this.handleUse(record.id, checked)}
                    />
                );
              },
            },
          ];


    return (
      <Modal
        title={`${reportName}`}
        width="70%"
        closable={true}
        onCancel={this.closeModal}
        visible={modalVisible}
        maskClosable={false}
        destroyOnClose={true}
        centered
        footer={[
          <Button key="Cancel" onClick={() => { handleCancel('searchModalVisible') }}>{t(`general.close`)}</Button>,
        ]}
      >

        <Table
          className="searchResult"
          dataSource={tableData}
          rowKey="id"
          pagination={pagination}
          rowClassName={this.getRowClassName}
          loading={tableLoading}
          scroll={{ x: '100%', y: 500 }} // 设置滚动属性
        >
        {/* {columns.map((column, index) => (
          <Table.Column
            key={index} // 使用索引作为 key
            title={column.name}
            dataIndex={column.name}
            ellipsis={true}
          />
        ))} */}
        
        {additionalColumns.map((column, index) => (
            <Table.Column
              key={index + columns.length} // 使用索引加上 columns.length 作为 key
              title={column.title}
              dataIndex={column.dataIndex}
              ellipsis={true}
              render={column.render} // 添加 render 属性
            />
          ))}


          <Table.Column width={200} align="center" title={t(`general.action`)} key="Action" render={(text, record) => {
            return (
              <>
              
                  <Button type="link" onClick={() => this.handleDelete(record.id)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
                
            
                  <Button type="link" onClick={() => this.handleTemporaryUse(record.searchData)} icon={<SwapOutlined />} title={t(`general.use`)}/>
                
              </>
            )
          }}/>
        </Table>
      </Modal>
    )
  }
}

export default withTranslation()(SearchDataModal)
